import { useLazyQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

type GetChannelFunction = (
  params: API.ChannelQueryVariables,
) => Promise<NonNullable<API.ChannelQuery['channel']> | undefined>;

export function useGetChannelLazyQuery(): GetChannelFunction {
  const [getChannel] = useLazyQuery<API.ChannelQuery, API.ChannelQueryVariables>(
    Queries.channel.getChannel,
  );
  return useCallback<GetChannelFunction>(
    async ({ id, slug }: API.ChannelQueryVariables) => {
      if (!isNil(id) || !isNil(slug)) {
        const response = await getChannel({ variables: { id, slug } });
        return response.data?.channel ?? undefined;
      }
    },
    [getChannel],
  );
}
